var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"font-family":"Quicksand"},attrs:{"id":"app"}},[_c('menuTop'),_c('iconosWyC'),_c('router-view'),_c('redessociales')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }